import { createContext } from 'react';

const ConversationContext = createContext();

export default ConversationContext;
